export const STAGED_CHAT_PROMPT_QUERY_PARAM = 'stagedChatPrompt'

const STAGED_CHAT_PROMPT_STORAGE_PREFIX = 'tripPlanner:stagedChatPrompt:'

interface StagedChatPrompt {
  prompt: string
}

const stagedChatPromptMemory = new Map<string, StagedChatPrompt>()

function getStagedChatPromptStorageKey(token: string): string {
  return `${STAGED_CHAT_PROMPT_STORAGE_PREFIX}${token}`
}

function createStagedChatPromptToken(): string {
  return `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`
}

interface StagedChatPromptReference {
  token: string
}

export function stageChatPrompt(prompt: string): StagedChatPromptReference {
  const token = createStagedChatPromptToken()
  const stagedPrompt: StagedChatPrompt = {
    prompt,
  }

  try {
    window.sessionStorage.setItem(
      getStagedChatPromptStorageKey(token),
      JSON.stringify(stagedPrompt),
    )
  } catch {
    stagedChatPromptMemory.set(token, stagedPrompt)
  }

  return { token }
}

export function buildStagedChatPromptQuery(prompt: string): string {
  const stagedPrompt = stageChatPrompt(prompt)
  const queryParams = new URLSearchParams({
    [STAGED_CHAT_PROMPT_QUERY_PARAM]: stagedPrompt.token,
  })

  return queryParams.toString()
}

export function consumeStagedChatPrompt(
  token: string | null | undefined,
): string | undefined {
  if (!token) return undefined

  const storageKey = getStagedChatPromptStorageKey(token)

  if (typeof window !== 'undefined') {
    try {
      const stagedPrompt = JSON.parse(window.sessionStorage.getItem(storageKey) ?? 'null') as StagedChatPrompt | null
      window.sessionStorage.removeItem(storageKey)

      if (typeof stagedPrompt?.prompt === 'string') {
        return stagedPrompt.prompt
      }
    } catch {
      try {
        window.sessionStorage.removeItem(storageKey)
      } catch {
        // no-op: storage may be unavailable, in which case the in-memory fallback is used.
      }
    }
  }

  const stagedPrompt = stagedChatPromptMemory.get(token)
  stagedChatPromptMemory.delete(token)

  if (typeof stagedPrompt?.prompt === 'string') {
    return stagedPrompt.prompt
  }

  return undefined
}
